const isEnvLocalDev = () => window.location.hostname.includes('localhost');

export default isEnvLocalDev;
